import { useEffect, useState } from "react";
import HomePageV3 from "./HomePageV3";
import { getTcDetailFoTrace } from "./api";
import { useParams } from "react-router-dom";
import HomePageV4 from "./HomePageV4";

const HomePage = () => {
  const [traceVersion, setTraceVersion] = useState();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const getTraceDetails = async (id) => {
    setIsLoading(true);
    try {
      const res = await getTcDetailFoTrace(id);
      if (res?.status === true) {
        setTraceVersion(res?.data?.data?.__traceVersion);
      }
    } catch (error) {
      console.log(error.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getTraceDetails(id);
  }, []);

  return (
    <>
      {traceVersion === 4 ? (
        <HomePageV4 id={id} traceVersion={traceVersion} />
      ) : (
        <HomePageV3 id={id} traceVersion={traceVersion} />
      )}
    </>
  );
};

export default HomePage;
